import React from "react";
import { Link } from "react-router-dom";
import "./social-only-account-notice.css";

export function SocialOnlyAccountNotice() {
  return (
    <div className="social-only-account-notice" role="status">
      <p className="social-only-account-notice__text">
        Esta cuenta pertenece a la red social de OpenReferences. Entra desde la red social; desde allí podrás activar el acceso profesional o de empresa.
      </p>
      <Link className="social-only-account-notice__link" to="/login?social=true">
        Entrar en la red social
      </Link>
    </div>
  );
}
